class TopElementor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-elementor-drawer-trigger').on('click', function(){
      $('html').toggleClass('is-elementor-drawer-open');
      scrollBan();
    });

    let scrollTimer;
    $(window).on('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        if($(window).scrollTop() > 100) {
          $('html').addClass('is-scroll');
        } else {
          $('html').removeClass('is-scroll');
        }
      }, 100);
    });

  }
}
